import React, { useState } from 'react'
import { OmDialog, OmInput } from '@owma/kit'
import { useTranslation } from 'react-i18next'
import { isEmail } from 'utils/ui'

import styles from './style.module.scss'

interface EmailInputProps {
  onClose: () => void
  onSave: (data: { email: string }) => void
  initialEmail?: string
}

const EmailInput: React.FC<EmailInputProps> = ({ onClose, onSave, initialEmail }) => {
  const { t } = useTranslation()
  const [email, setEmail] = useState(initialEmail || '')

  const handleSave = (): void => {
    if (!isEmail(email.trim())) return

    onSave({
      email: email.trim(),
    })
    onClose()
  }

  return (
    <OmDialog
      title={t('settings.accountTabs.forwardingEmail')}
      open={true}
      closable={false}
      footer={null}
      width={400}
      className={styles.modal}
      centered
    >
      <div className={styles.container}>
        <div className={styles.formGroup}>
          <label className={styles.label}>{t('app.dock.email')}</label>
          <div className={styles.inputWrapper}>
            <OmInput
              placeholder={t('app.dock.email')}
              value={email}
              onChange={(value) => setEmail(value)}
              className={styles.input}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            {t('common.button.cancel')}
          </button>
          <button
            className={`${styles.saveButton} ${!isEmail(email.trim()) ? styles.disabled : ''}`}
            onClick={handleSave}
            disabled={!isEmail(email.trim())}
          >
            {t('common.button.ok')}
          </button>
        </div>
      </div>
    </OmDialog>
  )
}

export default EmailInput
